<template>
  <div class="test-tab">
  </div>
</template>

<script>
export default {
  name: 'TestTab',
  props: {
    msg: String
  }
}
</script>

<style scoped>
</style>
